import React from 'react';
import styles from './UpdateNotification.module.css';

interface UpdateNotificationProps {
  visible: boolean;
}

export function UpdateNotification({ visible }: UpdateNotificationProps) {
  if (!visible) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.banner}>
        <p className={styles.text}>Dostępna nowa wersja aplikacji.</p>
        <button
          className={styles.button}
          onClick={() => window.location.reload()}
        >
          Odśwież
        </button>
      </div>
    </div>
  );
}
